import { gql } from '@apollo/client';

const GET_MAXIMUM_PROGRAM_YEAR = gql`
  query GetMaximumProgramYear {
    maximumProgramYear
  }
`;

export default GET_MAXIMUM_PROGRAM_YEAR;
